// extracted by mini-css-extract-plugin
export default {"container":"CJ-z","topReviewHeading":"DJ-z","criticalReview":"EJ-z","favorableReview":"FJ-z","vsSeparator":"GJ-z"};